function hexToRgb(hex) {
    // Remove the '#' character if it exists
    hex = hex.replace(/^#/, '');
  
    // Parse the hex color components
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
  
    // Return the RGB color as an object
    return {
      r: r,
      g: g,
      b: b
    };
  }
  
  // Example usage:
//   const hexColor = "#336699";
//   const rgbColor = hexToRgb(hexColor);
//   console.log("RGB Color:", rgbColor);
  
/**
 * Pick black or white text for a background color using YIQ perceived
 * brightness. Mid-tones (e.g. Looppanel blue #5B7EDB) keep white text;
 * only clearly light colors get black. Falls back to white for invalid input.
 * @param {string} hex e.g. '#5B7EDB' or '#FFF'
 * @returns {'#000000' | '#FFFFFF'}
 */
export function getContrastTextColor(hex) {
  let value = String(hex || '').trim().replace(/^#/, '');
  if (/^[0-9a-f]{3}$/i.test(value)) {
    value = value.split('').map((char) => char + char).join('');
  }
  if (!/^[0-9a-f]{6}$/i.test(value)) return '#FFFFFF';

  const { r, g, b } = hexToRgb(value);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness >= 150 ? '#000000' : '#FFFFFF';
}

export default hexToRgb;